import { useEffect, useRef } from 'react'
import { mergeRefs } from '@grupoboticario/flora-react-utils'
import { UseFloraCheckboxProps } from './types'

export const useFloraCheckbox = ({ forwardedRef, indeterminate }: UseFloraCheckboxProps) => {
  const internalRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (internalRef?.current) {
      internalRef.current.indeterminate = !!indeterminate
    }
  }, [indeterminate])

  return {
    ref: mergeRefs(forwardedRef, internalRef),
  }
}
